import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { SnackbarProps } from "../models/toast.model"

type CommonSharedUISliceProps = {
  snackBar: SnackbarProps | null
}

const initialState: CommonSharedUISliceProps = {
  snackBar: null,
}

export const commonSharedUISlice = createSlice({
  name: "common-shared-ui-slice",
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<SnackbarProps>) => {
      state.snackBar = action.payload
    },
    clearToast: (state) => {
      state.snackBar = null
    },
  },
})

export const { showToast, clearToast } = commonSharedUISlice.actions
